import { render, staticRenderFns } from "./FeaturedBrands.vue?vue&type=template&id=c0fac846&scoped=true&"
import script from "./FeaturedBrands.vue?vue&type=script&lang=js&"
export * from "./FeaturedBrands.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedBrands.vue?vue&type=style&index=0&id=c0fac846&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fac846",
  null
  
)

export default component.exports